
























import { Component, Vue } from 'vue-property-decorator';
import {
  Item, Language, items, i18n,
} from '../data';

const TICKS_PER_MINUTE = 60 * 60;

interface Target {
  item: Item;
  perMinute: number;
}

@Component
export default class RecipeBrowser extends Vue {
  private items = items;

  private i18n = i18n;

  private language: Language = 'ENUS';

  private targets: Target[] = [];

  private craftingSpeedModifier = 0.75;

  searchItems(query: string): Item[] {
    if (query.length < 1) { return []; }
    const regex = new RegExp(query, 'i');
    return this.items.filter((item) => item.productOf.length > 0
      && (item.Name.match(regex)
      || item.IconPath.match(regex)
      || this.i18n.ZHCN[item.Name].match(regex)
      || this.i18n.ENUS[item.Name].match(regex)
      || this.i18n.FRFR[item.Name].match(regex)));
  }

  suggest(item: Item): string {
    return this.i18n[this.language][item.Name];
  }

  addTarget(item: Item | undefined) {
    if (!item) return;
    const product = item.productOf[0];
    if (this.targets.find((t) => t.item === item)) return;
    this.targets.push({
      item,
      perMinute: (product.count / product.recipe.TimeSpend)
        * TICKS_PER_MINUTE
        * this.craftingSpeedModifier,
    });
  }

  removeTarget(target: Target) {
    this.targets.splice(this.targets.indexOf(target), 1);
  }
}
